
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/ristoranti/[slug]",
      function () {
        return require("private-next-pages/stores/ristoranti/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/ristoranti/[slug]"])
      });
    }
  